module.exports = __webpack_public_path__ + "images/wxwork/ic-wcwf-3-4a8195c83f9d7fb57e0a09ab50833f90.png";